<template>
  <div>
    <Breadcrumb :title="'Unit Program Allocation'"></Breadcrumb>
    <BaseSearchBar :config="SearchUnitProgramAllocation" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar
      :config="UnitProgramAllocationToolBarConfig"
      @buttonClicked="UnitProgramAllocationToolBarClick"
    ></BaseToolBar>
    <BaseGrid
      :mode="'editform'"
      :excelExport="excelExport"
      :config="GridConfig"
      :data="GridData"
      @InfoItem="gotoUnitProgramAllocationDetails"
    ></BaseGrid>
  </div>
</template>

<script>
// Breadcrumb implementation
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";

// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
  GridConfig,
  ToolBarConfig,
  ProgramUpdatefields
} from "./UnitProgramAllocation.js";

import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import deepGroupBy from "@/services/groupByUtil.js";
import BaseModelAllocationReport from "@/models/BaseModelAllocationReport.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js"
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
//var loader;
export default {
  name: "UnitProgramAllocation",
  mixins: [apiUtil, funcUtil, toolbarUtility],

  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid
  },

  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls"
    ])
  },

  data: function() {
    return {
      // Base Grid implementation
      GridConfig: GridConfig,
      UnitProgramAllocationGridId: GridConfig.grid.gridId,

      BaseModelProgram: BaseModelProgram,
      BaseInvestmentValuation: BaseInvestmentValuation,
      BaseModelInputControl: BaseModelInputControl,
      BaseModelUnitRunningTotal: BaseModelUnitRunningTotal,
      BaseModelAllocation: BaseModelAllocation,
      BaseModelTransactionLog : BaseModelTransactionLog,
      BaseModelAllocationReport: BaseModelAllocationReport,
      UnitProgramAllocationMasterData: [],

      // Base Toolbar with button implementation
      UnitProgramAllocationToolBarConfig: ToolBarConfig,
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] }
      },

      // Base Searchbar implementation
      SearchUnitProgramAllocation: {
        SearchData: ""
      },
      IsAllocationCreated: false,

      ProgramAPIData: [],
      InvestmentValuationAPIData: [],
      UnitRunningTotalAPIData: [],
      AllocationReportAPIData: [],
      AllocationReportUpdateData: [],

      GridData: [],
      AllocationData: [],
      AllocationReportData: [],
      ProgramUpdateData: [],
      AllocationDeleteItemsArray: [],
      classRunningTotalDict : {},
      classRunningTotalDictPartner : {},
      selectedDate : "",
      ExceptionProgram : {
          "Master" : {"Id" : 81,"ProgramID" : 30010, "InvestmentId" : 49,"InvestmentInvestmentId" : 500010},
         "Child" : {"Id" : 82,"ProgramID" : 30011, "InvestmentId" : 50,"InvestmentInvestmentId" : 500011}
      }
    };
  },

  mounted() {
    const self = this;
    // Tool bar grid setting
    //self._loadGridSettings(self.UnitProgramAllocationGridId);

    let grid = $("#" + self.UnitProgramAllocationGridId).data("kendoGrid");
    grid.bind("dataBound", self.UpdateUnitProgramAllocationMasterData);
    $("#dropdownTaxPeriod").bind("change", self.PeriodChangedEventHandler);
    //self.getProgramData();

    self.getInputControls();
    self.getBaseGridData();
  },

  methods: {
    ...mapActions("postModule", [
      "UpdateAllItems",
      "deleteAllItem",
      "CreateAllItems",
      "UpdateItems"
    ]),
    ...mapActions("getModule", ["AddCollection"]),
    ...mapState("getModule", ["CommonCollection"]),

    gotoUnitProgramAllocationDetails: function(e) {
      const self = this;
      const grid = $("#" + self.UnitProgramAllocationGridId).data("kendoGrid");
      const dataItem = grid.dataItem(window.$(e.currentTarget).closest("tr"));
      if (dataItem.AllocationStatus == "Completed") {
        this.AddCollection({ key: "Title", value: dataItem.Title });
        this.AddCollection({
          key: "InvestmentId",
          value: dataItem.InvestmentId
        });
        this.AddCollection({
          key: "TaxYearQuarter",
          value: dataItem.TaxYearQuarter
        });

        this.$router.push("/valuation/UnitProgramAllocationDetail");

        // this.$router.push(
        //   "/valuation/allocation/" +
        //     dataItem.Title +
        //     "/" +
        //     dataItem.InvestmentId +
        //     "/" +
        //     dataItem.TaxYearQuarter
        // );
      } else {
        this._AlertPopup("Please Allocate the Program!", "info");
      }
    },

    PeriodChangedEventHandler(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      let self = this;
      // alert($('#dropdownTaxPeriod').val());
      let selectedPeriod = $("#dropdownTaxPeriod").val();
      //   self.DirectInvestmentInfoData=[];
      //   let IVTaxYearQuarterFilteredData = self.DirectInvestmentData.filter(item =>{return item.TaxYearQuarter == selectedPeriod});
      //   self.DirectInvestmentInfoData=IVTaxYearQuarterFilteredData;
      // }
      self.getProgramData();
    },

    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
      //console.log(response);
      Object.keys(self.dropdowns).forEach(key => {
        self.dropdowns[key].dataSource = response[key];
        // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
      });

      //Filling the Drop down options for the Grid DropDown Columns
      // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
      // let options = '<option value="1">One</option>';
      // $("#dropdownTaxPeriod").empty();
      // let options = "";
      // if (self.dropdowns.TaxPeriod.dataSource.length > 0) {
      //   for (
      //     let index = 0;
      //     index < self.dropdowns.TaxPeriod.dataSource.length;
      //     index++
      //   ) {
      //     const optionvalue = self.dropdowns.TaxPeriod.dataSource[index];
      //     //select the recent value
      //     if (self.dropdowns.TaxPeriod.dataSource.length - index == 1) {
      //       options =
      //         options +
      //         '<option value="' +
      //         optionvalue.Option +
      //         '" selected >' +
      //         optionvalue.Option +
      //         "</option>";
      //     } else {
      //       options =
      //         options +
      //         '<option value="' +
      //         optionvalue.Option +
      //         '">' +
      //         optionvalue.Option +
      //         "</option>";
      //     }
      //   }
      //   $("#dropdownTaxPeriod").append(options);
      if(self.dropdowns.TaxPeriod.dataSource.length>0)
        {
         self.dropdowns.TaxPeriod.dataSource= _.orderBy(self.dropdowns.TaxPeriod.dataSource,['Option'], ['asc']);
        }
      $("#dropdownTaxPeriod").kendoDropDownList({
        dataSource: self.dropdowns.TaxPeriod.dataSource,
        dataTextField: "Option",
        dataValueField: "Option"
      });
      if (self.dropdowns.TaxPeriod.dataSource.length > 0) {
        // get a reference to the dropdown list and assign the latest value
        let dropdownlist = $("#dropdownTaxPeriod").data("kendoDropDownList");
        dropdownlist.select(self.dropdowns.TaxPeriod.dataSource.length - 1);

        self.PeriodChangedEventHandler();
      } else {
        //   self.getDefaultPeriodDirectInvestmentData();
        //display the empty grid if the Period dropdown is not having the proper values
        self.DirectInvestmentInfoData = [];
      }
      // });
    },

    async getBaseGridData() {
      await this.getProgramData();
      this._loadGridSettings(this.UnitProgramAllocationGridId);
    },

    UpdateUnitProgramAllocationMasterData: function(
      fromFilter,
      filterMasterData
    ) {
      const self = this;
      if (fromFilter == true) {
        self.UnitProgramAllocationMasterData = filterMasterData;
      } else {
        self.UnitProgramAllocationMasterData = $(
          "#" + self.UnitProgramAllocationGridId
        )
          .data()
          .kendoGrid.dataSource.data();
      }
    },

    allocateProgram() {
      const self = this;
      let localGridData = [];
      const grid = $("#" + self.UnitProgramAllocationGridId).data("kendoGrid");
      if (grid.select().length > 0) {
        grid.select().each(function(selectIndex) {
          self.classRunningTotalDict={};
          //self.classRunningTotalDictPartner={};
          //console.log("Grid Index",selectIndex,self.classRunningTotalDict,self.classRunningTotalDictPartner);
          const grdDataItem = grid.dataItem(this);
          localGridData.push(grdDataItem);
          let calculatedPartnerInfo = [];
          let filterQuery = {
            filter: "ProgramId eq " + grdDataItem.Id
          };
          let result = self.withFilter(
            self.BaseModelUnitRunningTotal.list,
            filterQuery
          );

          let transData = self.withFilter(self.BaseModelTransactionLog.list,filterQuery)

          function getTaxandPriorTaxPeriod(taxYear, taxQuarter) {
              if (taxQuarter == "Q1") {
                return taxYear + "/3/31";
              } else if (taxQuarter == "Q2") {
                return taxYear + "/6/30";
              } else if (taxQuarter == "Q3") {
                return taxYear + "/9/30";
              } else {
                return taxYear + "/12/31";
              }
          }
          
          self.selectedDate = grdDataItem.TaxYearQuarter.split(" ");
          //console.log(self.selectedDate);
          let currentDate = new Date(getTaxandPriorTaxPeriod(self.selectedDate[0],self.selectedDate[1]));
          //console.log('currentDate',moment(currentDate).format("DD/MM/YYYY"));
          currentDate = moment(currentDate,"DD/MM/YYYY").add('days',1);
          let tranData = _.filter(transData, function(o) { return moment(o.TransactionDate) <= moment(currentDate) });
          console.log(transData);

        let mergeTranData;
        if(grdDataItem.Id == self.ExceptionProgram.Master.Id)
        {

          let filterQuery = {
            filter: "ProgramId eq " + self.ExceptionProgram.Child.Id
          };

          let resultMergeProgram = self.withFilter(self.BaseModelTransactionLog.list,filterQuery)
          //console.log("Result Merge Program",resultMergeProgram,currentDate);
          if(resultMergeProgram.length) {
            mergeTranData = _.filter(resultMergeProgram, function(o) { return moment(o.TransactionDate) <= moment(currentDate) });
            mergeTranData.forEach(function(item){
              item.ProgramId = self.ExceptionProgram.Master.Id;
              tranData.push(item);
            })
          }
        }

        var groupByResult;

          if(tranData.length) {
            const getConfig11 = item => item.PartnerId;
            const getConfig21 = item => item.UnitClass;
            const getConfig31 = item => item.UnitType;
            const getConfig41 = item => item.VestingType;
            const getConfig51 = item => item.BusinessEvent;

            groupByResult = deepGroupBy(
              tranData,
              getConfig11,
              getConfig21,
              getConfig31,
              getConfig41,
              //getConfig51
            );            
          }
          console.log(groupByResult);
          //let a = _.sumBy(groupByResult1,)


          //console.log("result before",result,grdDataItem.Id,self.ExceptionProgram.Master.Id); 

          // let resultMergeProgram;
          // if(grdDataItem.Id == self.ExceptionProgram.Master.Id)
          // {
          //     let filterQuery = {
          //       filter: "ProgramId eq " + self.ExceptionProgram.Child.Id
          //     };
          //     resultMergeProgram = self.withFilter(
          //       self.BaseModelTransactionLog.list,
          //       filterQuery
          //     )
          //     let result = _.filter(resultMergeProgram, function(o) { return moment(o.TransactionDate) <= moment(currentDate) });
          //     if(result.length) {
          //       result.forEach(function(item) {
          //         item.ProgramId = self.ExceptionProgram.Master.Id;
          //         tranData.push(item);
          //       });
          //       //result.concat(resultMergeProgram);
          //     }
          // }





          // Object.keys(groupByResult1).forEach(function(partnerKey,partnerIndex){
          //   let Partnerresult = groupByResult1[partnerKey];
          //   if(Partnerresult) {
          //     Object.keys(Partnerresult).forEach(function(classkey,index) {
          //       let PartnerClass = Partnerresult[classkey];
          //       if(PartnerClass) {
          //         Object.keys(PartnerClass).forEach(function(Unittypekey,index){
          //           let PartnerUnitType = PartnerClass[Unittypekey];
          //           if(PartnerUnitType) {
          //             Object.keys(PartnerUnitType).forEach(function(Vestingtypekey,index){
          //               let PartnerVestingType = PartnerUnitType[Vestingtypekey];
          //               console.log("PartnerVestingType",PartnerVestingType);
          //             })
          //           }
          //         })
          //       }
          //     })
          //   }
          // });


          //console.log("result after",result);

          if (tranData.length) {
            //Nested Grouping by partnerid,unitclass,unittype
            const getConfig1 = item => item.PartnerId;
            const getConfig2 = item => item.UnitClass;
            const getConfig3 = item => item.UnitType;
            const getConfig4 = item => item.VestingType;
            //const getConfig4 = item => item.BusinessEvent;

            // var groupByResult = deepGroupBy(
            //   result,
            //   getConfig1,
            //   getConfig2,
            //   getConfig3,
            //   getConfig4
            // );
            localGridData[selectIndex].Partners = [];
            localGridData[selectIndex].StoreRunningTotalByClass = {};
            localGridData[selectIndex].StoreRunningTotalByClassPartner = {};
            localGridData[selectIndex].PartnersGroupedData = groupByResult;
            localGridData[selectIndex].AdjustedTotalUnits = 0;
            // check for null while allocating!
            if (
              localGridData[selectIndex].ProjectedValue != null &&
              localGridData[selectIndex].CurrentValue != null
            ) {
              Object.keys(groupByResult).forEach(function(
                partnerkey,
                partnerindex
              ) {
                let Partnerresult = groupByResult[partnerkey];
                //console.log("Partner Class", Partnerresult);
                if (Partnerresult) {
                  Object.keys(Partnerresult).forEach(function(classkey, index) {
                    let PartnerClass = Partnerresult[classkey];
                    //console.log("Partner Unit Type", PartnerClass);
                    //console.log("Details --->"+ Partnerresult);
                    if (PartnerClass) {
                      Object.keys(PartnerClass).forEach(function(
                        Unittypekey,
                        index
                      ) {
                        //console.log("Unittypekey",Unittypekey);
                        let PartnerUnitType = PartnerClass[Unittypekey];
                    // if(PartnerUnitType && Unittypekey != "Treasury")
                    // {
                          Object.keys(PartnerUnitType).forEach(function(
                        Vestingtypekey,
                        index
                      )
                      {
                        
                        let PartnerVestingType = PartnerUnitType[Vestingtypekey];
                        //console.log("Data to be inserted", PartnerUnitType);
                        //console.log("Keys");

                        let units = 0;                
                        for (let i = 0; i < PartnerVestingType.length; i++) {
                          //Fix : undefined index is being passed to grid!
                          //localGridData[i] with localGridData[selectIndex]
                          // Exlude all Unit Pool == Treasury, to match FMV % with client data
                          //if(PartnerVestingType[i].UnitPool != "Treasury") {
                              let Ownership = self.getPartnerOwnership(localGridData[selectIndex].Id,classkey);
                              //console.log("Classkey",Ownership,PartnerVestingType[i].PartnerId,PartnerVestingType[i].UnitClass,PartnerVestingType[i].Unit *Ownership, classkey,PartnerVestingType[i].Unit);
                              self.StoreRunningTotalByClass(classkey,PartnerVestingType[i].Unit);
                              self.StoreRunningTotalByClassPartner(PartnerVestingType[i].PartnerId,classkey,PartnerVestingType[i].Unit *Ownership);
                              localGridData[selectIndex].AdjustedTotalUnits+=(PartnerVestingType[i].Unit *Ownership)

                              PartnerVestingType[i].AdjustedUnits=PartnerVestingType[i].Unit *Ownership
                              PartnerVestingType[i].FMVPercent =0;
                              PartnerVestingType[i].ProjectedValue = 0;
                              PartnerVestingType[i].CurrentValue = 0;
                              //After calculation put the values into partners attribute
                              localGridData[selectIndex].Partners.push(
                                PartnerVestingType[i]
                              );
                              calculatedPartnerInfo.push(PartnerVestingType[i]);
                              }

                        //}
                        

                      });
                    //}
                        //console.log("self.classRunningTotalDictPartner",self.classRunningTotalDictPartner,self.classRunningTotalDict);
                        //console.log("Partner ",calculatedPartnerInfo);
                      });
                    }
                  });
                }
              });
            }
            
            localGridData[selectIndex].StoreRunningTotalByClassPartner = self.classRunningTotalDictPartner;
            localGridData[selectIndex].StoreRunningTotalByClass = self.classRunningTotalDict;
            self.classRunningTotalDictPartner = {};
            self.classRunningTotalDict = {};
          }
        });
      } else {
        this._AlertPopup("Please select atleast one Program.", "info");
      }
      console.log("Local data", localGridData);

      self.AllocationData = [];

      if (localGridData.length) {

        for (let i = 0; i < localGridData.length; i++) {
          //console.log("(localGridData[i].Partners"+JSON.stringify(localGridData[i].Partners));
          if (localGridData[i].Partners) {
            for (let j = 0; j < localGridData[i].Partners.length; j++) {
              let insertData = {};
              insertData.ProgramId = localGridData[i].Id;
              insertData.InvestmentId = localGridData[i].InvestmentId;
              insertData.InvestmentInvestmentID =
                localGridData[i].InvestmentInvestmentID;
              insertData.InvestmentTitle = localGridData[i].InvestmentTitle;
              insertData.TaxYear = localGridData[i].TaxYear;
              insertData.TaxQuarter = localGridData[i].TaxQuarter;
              insertData.TaxYearQuarter = localGridData[i].TaxYearQuarter;

              //FMV Percentage 
              //console.log("Partner Details"+JSON.stringify(localGridData[i].Partners[j]));
              
              //let classRunningTotal=self.FetchRunningTotalByClass(localGridData[i].Partners[j].UnitClass);
              let classRunningTotal = localGridData[i].StoreRunningTotalByClass[localGridData[i].Partners[j].UnitClass];
              
              //let adjustedUnitsOld = self.FetchRunningTotalByClassPartner(localGridData[i].Partners[j].PartnerId,localGridData[i].Partners[j].UnitClass);
              let adjustedUnits = localGridData[i].StoreRunningTotalByClassPartner[localGridData[i].Partners[j].PartnerId][localGridData[i].Partners[j].UnitClass];
              //console.log("change",adjustedUnits);
              
              insertData.Percentage  = (classRunningTotal > 0) ?
                    adjustedUnits / classRunningTotal : 0;
              //console.log("classRunningTotal"+classRunningTotal);
              //console.log("FMV Percentage for "+localGridData[i].Partners[j].Id+" is "+insertData.Percentage);

              insertData.ProjectedValue =(localGridData[i].ProjectedValue)?
              (insertData.Percentage * localGridData[i].ProjectedValue):0

              insertData.CurrentValue =(localGridData[i].CurrentValue)?
              (insertData.Percentage *localGridData[i].CurrentValue):0
              
              insertData.Percentage = insertData.Percentage * 100;
              //FMV Percentage  Old
              // insertData.Percentage =
              // Math.round(((localGridData[i].Partners[j].AdjustedUnits/localGridData[i].AdjustedTotalUnits)*100)*10000)/10000;


              // insertData.ProjectedValue =(localGridData[i].ProjectedValue)?
              // Math.round((insertData.Percentage*0.01 *localGridData[i].ProjectedValue)*100)/100:0

              // insertData.CurrentValue =(localGridData[i].CurrentValue)?
              // Math.round((insertData.Percentage*0.01 *localGridData[i].CurrentValue)*100)/100:0


              insertData.PartnerId = localGridData[i].Partners[j].PartnerId;
              insertData.PartnerFullName =
                localGridData[i].Partners[j].PartnerFullName;
              insertData.UnitClass = localGridData[i].Partners[j].UnitClass;
              insertData.UnitType = localGridData[i].Partners[j].UnitType;
              insertData.VestingType=localGridData[i].Partners[j].VestingType;

              self.AllocationData.push(insertData);
            }
          }
        }
      }
      console.log("AllocationData", self.AllocationData);
      self.AllocationReportData = localGridData;
      self.RemoveDuplicatesInsertData();
      let AllocatedGridData = [];
      AllocatedGridData = localGridData.filter(
        obj => obj.AllocationStatus == "Completed"
      );
      if (AllocatedGridData.length > 0) {
        this._ConfirmationPopup(
          "Reallocation of Investment selected will delete previous data.",
          "Confirm"
        ).then(response => {
          if (response.value) {
            self.CreateUnitValueAllocation();
            //self.CreateAllocationReport();
          }
        });
      } else {
        self.CreateUnitValueAllocation();
        //self.CreateAllocationReport();
      }
      
      console.log("StoreRunningTotalByClass", self.classRunningTotalDict);
      console.log("StoreRunningTotalByClass", self.classRunningTotalDictPartner);
      console.log("AllocationData", self.AllocationData);
    },
    CreateUnitValueAllocation() {
      const self = this;
      //loader = self.$loading.show();
       self._APICrudPopup("APICrudpopup");
      //1.Find Investment Id for which records to be deleted
      let uniqueInvestmentId = _.uniq(
        _.map(self.AllocationData, "InvestmentId")
      );
      //2 Fetch data from Unit investment valuation
      let AllocationApiData = self.withFilter(self.BaseModelAllocation.list);
      //3 Find Allocation list ID's to be deleted
      self.AllocationDeleteItemsArray = [];
      let selectedPeriod = $("#dropdownTaxPeriod").val();
      for (let i = 0; i < uniqueInvestmentId.length; i++) {
        let result = _.filter(AllocationApiData, function(obj) {
          // console.log(obj.InvestmentId,uniqueInvestmentId[i]);
          if(obj.InvestmentId != null) {
          return (
            obj.InvestmentId.toString()
              .trim()
              .toLowerCase() ==
              uniqueInvestmentId[i]
                .toString()
                .trim()
                .toLowerCase() &&
            obj.TaxYearQuarter.toString()
              .trim()
              .toLowerCase() ==
              selectedPeriod
                .toString()
                .trim()
                .toLowerCase()
          );            
          }

          // return (
          //   obj.InvestmentId.toString()
          //     .trim()
          //     .toLowerCase() ==
          //     uniqueInvestmentId[i]
          //       .toString()
          //       .trim()
          //       .toLowerCase() &&
          //   obj.TaxYearQuarter.toString()
          //     .trim()
          //     .toLowerCase() ==
          //     selectedPeriod
          //       .toString()
          //       .trim()
          //       .toLowerCase()
          // );

        });

        if (result) {
          result.forEach(element => {
            self.AllocationDeleteItemsArray.push({ Id: element.Id });
          });
          //self.AllocationDeleteItemsArray.push({"Id": result.Id});
        }
      }
      let createdobject = {
        Allocation: {
          config: self.BaseModelAllocation,
          createData: self.AllocationData,
          processInBatches:true
        }
      };

      if (self.AllocationDeleteItemsArray.length > 0) {
        //4.Deleted earlier allocation data for investment
        let deletedobject = {
          Allocation: {
            config: self.BaseModelAllocation,
            deleteData: self.AllocationDeleteItemsArray,
            processInBatches:true
          }
        };
        try{
        self.deleteAllItem(deletedobject).then(res => {
          //5.Create Data into Allocation list with update data
          if (self.AllocationData.length > 0) {
            self.CreateAllItems(createdobject).then(res => {
              self.IsAllocationCreated = true;
              self.CreateAllocationReport();
            });
          } else {
            self.CreateAllocationReport();
          }
        });
        }
        catch(error)
        {
          self._AlertPopup("Some Error Occurred!","info");
        }
      } else {
        //5.Create Data into Allocation list with update data
        try{
        if (self.AllocationData.length > 0) {
          self.CreateAllItems(createdobject).then(res => {
            self.IsAllocationCreated = true;
            self.CreateAllocationReport();
          });
        } else {
          self.CreateAllocationReport();
        }
        //this._deleteAllItems(deletedobject);
      }
      catch(error){
        self._AlertPopup("Some Error Occurred!","info");
      }
      } 
    },

    CreateAllocationReport() {
      const self = this;
      let uniqueProgramId = _.uniq(_.map(self.AllocationReportData, "Id"));

      let AllocationReportData = self.withFilter(
        self.BaseModelAllocationReport.list
      );
      let selectedPeriod = $("#dropdownTaxPeriod").val();
      self.AlloactionReportDeleteItemsArray = [];
      for (let i = 0; i < uniqueProgramId.length; i++) {
        let result = _.filter(AllocationReportData, function(obj) {
          return (
            obj.ProgramId.toString()
              .trim()
              .toLowerCase() ==
              uniqueProgramId[i]
                .toString()
                .trim()
                .toLowerCase() &&
            obj.TaxYearQuarter.toString()
              .trim()
              .toLowerCase() ==
              selectedPeriod
                .toString()
                .trim()
                .toLowerCase()
          );
        });

        if (result) {
          if (result) {
            result.forEach(element => {
              self.AlloactionReportDeleteItemsArray.push({ Id: element.Id });
            });
          }
        }
      }

      //Prepare Alloaction Report data
      self.AllocationReportUpdateData = [];
      for (let i = 0; i < self.AllocationReportData.length; i++) {
        let AllocationUpdateData = {};
        AllocationUpdateData.ProgramId = self.AllocationReportData[i].Id;
        AllocationUpdateData.TaxYear = self.AllocationReportData[i].TaxYear;
        AllocationUpdateData.TaxQuarter =
          self.AllocationReportData[i].TaxQuarter;
        AllocationUpdateData.TaxYearQuarter =
          self.AllocationReportData[i].TaxYearQuarter;
        if (!self.IsAllocationCreated && self.AllocationReportData[i].PartnersGroupedData) {
          AllocationUpdateData.Status = "Error";
        } else if (!self.AllocationReportData[i].PartnersGroupedData) {
          AllocationUpdateData.Status = "No Partners associated with this program.";
        } else if (
          self.AllocationReportData[i].ProjectedValue != null &&
          self.AllocationReportData[i].CurrentValue != null
        ) {
          AllocationUpdateData.Status = "Completed";
        } else {
          AllocationUpdateData.Status = "IncompleteData";
        }
        AllocationUpdateData.ProgramTitle = self.AllocationReportData[i].Title;
        self.AllocationReportUpdateData.push(AllocationUpdateData);
      }
      let createdobject = {
        AllocationReport: {
          config: self.BaseModelAllocationReport,
          createData: self.AllocationReportUpdateData,
          processInBatches:true
        }
      };

      //Deletion starts
      if (self.AlloactionReportDeleteItemsArray.length > 0) {
        //4.Deleted earlier allocation data for investment
        let deletedobject = {
          AllocationReport: {
            config: self.BaseModelAllocationReport,
            deleteData: self.AlloactionReportDeleteItemsArray,
            processInBatches:true
          }
        };
        try{
        self.deleteAllItem(deletedobject).then(res => {
          if (self.AllocationReportUpdateData.length > 0) {
            self.CreateAllItems(createdobject).then(res => {
              self.getProgramData();
              //loader.hide();
              self._AlertPopup("Program allocated successfully", "success");
            });
          }
        })
        }
        catch(error)
        {
          self._AlertPopup("Some Error Occurred!","info");
        }
      } else {
        if (self.AllocationReportUpdateData.length > 0) {
          self.CreateAllItems(createdobject).then(res => {
            self.getProgramData();
            self._AlertPopup("Program allocated successfully", "success");
          }).catch(error=>{
              self._AlertPopup("Some Error Occurred!","info");
          }).finally(()=>{
            //loader.hide();
          })
        }
      }
    },

    RemoveDuplicatesInsertData: function() {
      const self = this;
      let arr = self.AllocationData;
      let flag = 0;
      let duplicate = [];

      let UniqueInsertData = arr.reduce(function(accumulator, current) {
        if (checkIfAlreadyExist(current)) {
          return accumulator;
        } else {
          return accumulator.concat([current]);
        }

        function checkIfAlreadyExist(currentVal) {
          return accumulator.some(function(item) {
            return (
              item.ProgramId === currentVal.ProgramId &&
              item.InvestmentId === currentVal.InvestmentId &&
              item.PartnerId === currentVal.PartnerId &&
              item.UnitClass === currentVal.UnitClass 
              //&& item.UnitType === currentVal.UnitType
            );
          });
        }
      }, []);
      //this.dataExcel=a;
      self.AllocationData = UniqueInsertData;
    },

    // Grid search
    filterGrid: function() {
      const self = this;
      const currentMasterdata = self.GridData;

      let filteredData = self._filterGrid(
        self.GridData,
        self.SearchUnitProgramAllocation.SearchData
      );

      $("#" + self.UnitProgramAllocationGridId)
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateUnitProgramAllocationMasterData(true, currentMasterdata);
    },

    // Toolbar Submit Forfeiture butt, Generate Document
    UnitProgramAllocationToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id === "btnAllocate") {
        self.allocateProgram();
      }
      if (e.id == "btnRefresh") {
        self.refreshGrid();
      }
      self._baseToolBarEvents(self.UnitProgramAllocationGridId, ...arguments);
    },

    refreshGrid: function() {
      this.getBaseGridData();
    },

    getProgramData() {
      const self = this;

      let bundleObject = {
        Program: {
          config: self.BaseModelProgram
        },
        InvestmentValuation: {
          config: BaseInvestmentValuation
        },
        AllocationReport: {
          config: BaseModelAllocationReport
        }
      };

      let response = this.getAllItemFilter(bundleObject);

      self.ProgramAPIData = JSON.parse(JSON.stringify(response.Program));
      self.InvestmentValuationAPIData = JSON.parse(
        JSON.stringify(response.InvestmentValuation)
      );
      //self.UnitRunningTotalAPIData = response.UnitRunningTotal;
      self.AllocationReportAPIData = JSON.parse(
        JSON.stringify(response.AllocationReport)
      );
      console.log("Program", self.ProgramAPIData);
      console.log("Investment", self.InvestmentValuationAPIData);
      console.log("Allocation report ", self.AllocationReportAPIData);
      let InvestmentValuation = self.InvestmentValuationAPIData.slice();
      let Program = self.ProgramAPIData.slice();
      let AllocationReport = self.AllocationReportAPIData.slice();

      //self.ProgramAPIData.slice();

      let selectedPeriod = $("#dropdownTaxPeriod").val();
      let matchFound = false;

      for (let i = 0; i < Program.length; i++) {
        if (Program[i].InvestmentId) {
          let result = InvestmentValuation.filter(function(obj) {
            if (obj.InvestmentId && obj.TaxYearQuarter) {
              return (
                obj.InvestmentId.toString()
                  .trim()
                  .toLowerCase() ==
                  Program[i].InvestmentId.toString()
                    .trim()
                    .toLowerCase() &&
                obj.TaxYearQuarter.toString()
                  .trim()
                  .toLowerCase() ==
                  selectedPeriod
                    .toString()
                    .trim()
                    .toLowerCase()
              );
            }
          })[0];
          if (result) {
            Program[i].matchFound = true;
            Program[i].TaxYearQuarter = result.TaxYearQuarter;
            Program[i].ProjectedValue = result.ProjectedValue;
            Program[i].CurrentValue = result.CurrentValue;
            Program[i].CurrentValue = result.CurrentValue;
            Program[i].TaxYear = result.TaxYear;
            Program[i].TaxQuarter = result.TaxQuarter;
            
            //Program[i].TaxYearQuarter = result.TaxYearQuarter;
          }
        }
      }

      let SummaryGridData = Program.filter(obj => obj.matchFound == true);

      for (let i = 0; i < SummaryGridData.length; i++) {
        if (SummaryGridData[i].Id) {
          let result = AllocationReport.filter(function(obj) {
            if (obj.ProgramId && obj.TaxYearQuarter) {
              return (
                obj.ProgramId.toString()
                  .trim()
                  .toLowerCase() ==
                  SummaryGridData[i].Id.toString()
                    .trim()
                    .toLowerCase() &&
                obj.TaxYearQuarter.toString()
                  .trim()
                  .toLowerCase() ==
                  selectedPeriod
                    .toString()
                    .trim()
                    .toLowerCase()
              );
            }
          })[0];
          if (result) {
            SummaryGridData[i].AllocationStatus = result.Status;
            SummaryGridData[i].AllocationDate = result.AllocationDate;
            //Program[i].TaxYearQuarter = result.TaxYearQuarter;
          }
        }
      }

      if (SummaryGridData.length > 0) this.GridData = SummaryGridData;
      else this.GridData = [];
      console.log("Summary Data", SummaryGridData);

      //console.log("grid data", Program);
    },
    getPartnerOwnership(programId,unitClass){
       let filterQuery = {filter: "ProgramId eq " + programId};
       let unitClassResponse=this.withFilter(BaseModelUnitClass.list, filterQuery);
       //console.log("unitClassResponse",unitClassResponse);
       if (unitClassResponse) {
          let UnitClass = _.find(unitClassResponse, function(o) {
            return o.UnitClass == unitClass;
          });
          return UnitClass ? UnitClass.Ownership : 0;
       }
       return 0;
    },
    StoreRunningTotalByClass(unitClass,value){
      //console.log(unitClass,value);
      if(this.classRunningTotalDict[unitClass]){
        this.classRunningTotalDict[unitClass]+=value;
        //console.log("StoreRunningTotalByClass"+this.classRunningTotalDict);
      }else{
        this.classRunningTotalDict[unitClass]=value;
      }
      
    },

    StoreRunningTotalByClassPartner(partnerId,unitClass,value) {
      //console.log(classRunningTotalDictPartner.hasOwnProperty([partnerId]));
      if(this.classRunningTotalDictPartner.hasOwnProperty([partnerId])) {
        if(!this.classRunningTotalDictPartner[partnerId].hasOwnProperty(([unitClass]))) {
          //console.log(partnerId,unitClass,value);
          this.classRunningTotalDictPartner[partnerId][unitClass] = 0;
        }
        this.classRunningTotalDictPartner[partnerId][unitClass] += value;
      } else {
        //console.log("123",partnerId,unitClass,value);
        this.classRunningTotalDictPartner[partnerId] = {};
        this.classRunningTotalDictPartner[partnerId][unitClass] = value;
      }
    },

    FetchRunningTotalByClass(unitClass){
      return this.classRunningTotalDict[unitClass];
    },

    FetchRunningTotalByClassPartner(partnerId,unitClass) {
      //console.log(this.classRunningTotalDictPartner[partnerId][unitClass]);
      return this.classRunningTotalDictPartner[partnerId][unitClass];
    }
  }
};
</script>
